
import { Link } from 'react-router-dom';

const allIndustries = [
  { title: 'OB-GYN & Menopause', slug: 'obgyn-menopause', icon: 'ri-women-line' },
  { title: 'Preventive Medicine', slug: 'preventive-medicine', icon: 'ri-shield-cross-line' },
  { title: 'Functional & Integrative', slug: 'functional-integrative', icon: 'ri-leaf-line' },
  { title: 'Longevity & Anti-Aging', slug: 'longevity-antiaging', icon: 'ri-timer-line' },
  { title: 'BHRT & Hormone Therapy', slug: 'bhrt-hormone-therapy', icon: 'ri-flask-line' },
  { title: 'Cardiology', slug: 'cardiology', icon: 'ri-heart-pulse-line' },
  { title: 'Endocrinology', slug: 'endocrinology', icon: 'ri-test-tube-line' },
  { title: 'Urology', slug: 'urology', icon: 'ri-men-line' },
  { title: 'Medical Spas', slug: 'medical-spas', icon: 'ri-sparkling-line' },
  { title: 'Wellness Centers', slug: 'wellness-centers', icon: 'ri-mental-health-line' },
  { title: 'Primary Care', slug: 'primary-care-prevention', icon: 'ri-stethoscope-line' },
  { title: 'Nurse Practitioners', slug: 'nurse-practitioners', icon: 'ri-nurse-line' },
  { title: 'Physician Assistants', slug: 'physician-assistants', icon: 'ri-user-heart-line' },
  { title: 'Clinic Owners & Directors', slug: 'clinic-owners-directors', icon: 'ri-building-2-line' }
];

interface RelatedIndustriesProps {
  currentSlug?: string;
  limit?: number;
}

export default function RelatedIndustries({ currentSlug, limit = 6 }: RelatedIndustriesProps) {
  const industries = allIndustries.filter(i => i.slug !== currentSlug).slice(0, limit);

  return (
    <section className="py-20 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="text-xs uppercase tracking-[0.2em] text-[#7C3AED] font-bold mb-4">
            INDUSTRIES WE SERVE
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
            Marketing for Healthcare Specialties
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => (
            <Link
              key={index}
              to={`/industries/${industry.slug}`}
              className="bg-[#F9FAFB] p-6 rounded-xl hover:shadow-lg transition-all border border-gray-100 group"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-[#7C3AED] to-[#A855F7] rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${industry.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{industry.title}</h3>
              <span className="text-[#7C3AED] font-semibold text-sm flex items-center gap-1">
                Learn More <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/#industries"
            className="inline-flex items-center gap-2 text-[#7C3AED] font-semibold hover:underline"
          >
            View All Industries <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
